import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'PROCEDURE_CLONE_ERROR':
      return action.error;

    case 'PROCEDURE_CLONE_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'PROCEDURE_CLONE_LOADING':
      return action.loading;

    case 'PROCEDURE_CLONE_RESET':
      return false;

    default:
      return state;
  }
}

export function cloned(state = null, action) {
  switch (action.type) {
    case 'PROCEDURE_CLONE_SUCCESS':
      return action.cloned;

    case 'PROCEDURE_CLONE_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, cloned });
